import { Student } from '@/apis/family_application/requests'
import { RootState } from '@/storage/store'
import { useSelector } from 'react-redux'

export function useTypesafeStudent() {
  const { data, selectedStudentId } = useSelector(
    (state: RootState) => state.FamilyApplication
  )

  function getSelectedStudent(
    selectedStudentId: number | null,
    students: Student[] | null
  ) {
    return students?.find((student) => student.id === selectedStudentId)
  }

  const student = getSelectedStudent(selectedStudentId, data!.students)

  // this should be impossible
  // selected student should always be defined.
  // But if for some reason it's not this will help us spot the issue
  // might want to look into how we can
  if (!student) {
    throw new Error('No student found - redirecting')
  }

  return {
    student,
    fullName: `${student.first_name} ${student.last_name}`,
  }
}
